<template>
    <div>
        <section class="breadcrumb-section cart">
            <div class="container">
                <nav aria-label="breadcrumb" v-if="false">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Thankyou
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <!-- <section class="cart_page pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-4"></div>
                    <div class="col-md-4 tahnkyou_center">
                        <div>
                            <h1>Thank you!</h1>
                            <p>
                                Your order has been placed, view your order
                                <router-link
                                    :to="{
                                        name: 'Order_detail',
                                        params: {
                                            id: this.$route.params.order_id
                                        }
                                    }"
                                    >{{
                                        this.$route.params.unique_order_id
                                    }}</router-link
                                >
                            </p>
                        </div>
                        <div
                            class="cart_buttons d-flex flex-wrap mt_28 align-items-center"
                        >
                            <a
                                href="/product-list/apparel/28"
                                class="btn btn_primary bg_primary_blue text_white py_18 px_28"
                            >
                                Continue Shoppin</a
                            >
                        </div>
                    </div>
                    <div class="col-md-4"></div>
                </div>
            </div>
        </section> -->
        <div class="cart_summary h-100 white_box py_52 px_52 cart-shipping-address">
        <div class="thankyou_submited_block">
            <div class="thankyou_icon_wrapper">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z" fill="white"/>
                </svg>
            </div>
            <h2 class="thankyou_title">Thank you!</h2>
             <p class="thankyou_message">
                                Your order has been placed, view your order
                                <router-link
                                    :to="{
                                        name: 'Order_detail',
                                        params: {
                                            id: this.$route.params.order_id
                                        }
                                    }"
                                    >{{
                                        this.$route.params.unique_order_id
                                    }}</router-link
                                >
                            </p>
                            <p class="thank-you-description">In order to ensure we meet your scheduled due date, please check your email for an order confirmation and please monitor your email inbox for important statuses and proof requests!</p>
           
            <a href="/product-list/apparel/28" class="continue_shopping_btn">
                CONTINUE SHOPPING
            </a>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Thankyou",
    /* eslint-enable */
    data() {
        return {};
    },
    components: {},
    mounted() {
        this.ifOrderIdNotFound();
    },
    methods: {
        ifOrderIdNotFound() {
            if (this.$route.params.order_id == null) this.$router.push("/");
            console.log(this.$route.params.order_id);
        }
    }
};
</script>
<style>
  .thankyou_submited_block  .thank-you-description{
        color: #414141;
        font-size: 16px;
        line-height: 24px;
        max-width: 800px;
        margin: 0 auto 32px auto;
    }
</style>
